import { useListEvents } from '@cocoonspace/sdk-js/domains/events/events'
import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import { useTranslation } from 'next-i18next'
import { useTracking } from '~/providers/tracking-provider'
import { DashboardCard } from './dashboard-card'

export const DashboardUpcomingEventsCard = () => {
	const { t } = useTranslation()
	const { track } = useTracking()

	const currentDate = dateTimeUtils()

	const { data: eventsCount, isLoading } = useListEvents(
		{
			from: currentDate.customFormat('dateTech'),
			to: currentDate.add(12, 'month').customFormat('dateTech'),
		},
		{
			query: {
				select: (events) => events.data.length || 0,
			},
		},
	)

	return (
		<DashboardCard
			isLoading={isLoading}
			title={t('cwDashboard:upcomingEvents.title') as string}
			subtitle={t('cwDashboard:upcomingEvents.subtitle') as string}
			link={{
				label: t('cwDashboard:upcomingEvents.linkLabel'),
				href: '/my-events',
				onClick: () => track.click('dashboard-seeMyBookings-link'),
			}}
			childrenClassName='text-6xl font-bold leading-none text-primary'
		>
			{eventsCount}
		</DashboardCard>
	)
}
